import React from 'react';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Error404 from '../../assets/images/logosvg.svg';

import authInstance from '../../config/authInstance';

const styles = theme => ({
  container: {
    minHeight: '100vh',
    // height: 'auto',
    // marginTop: '100px'
  },
  image: {
    maxWidth: '100%',
    maxHeight: '450px',
    width: '8%',
    paddingBottom: '3%',
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
  },
  paperContainer: {
    margin: 'auto',
    padding: '50px',
  },
  confirmationText: {
    width: '60%',
    margin: 'auto'
  }
});

class EmailConfirmation extends React.Component {

  state = {
    details: {},
  }

  componentDidMount() {
    let code = this.props.match.params.code;
    const token = code.slice(6);

    if (code.indexOf('change') === 0) {
      this.changeEmail(token)
        .then((response) => {
          this.setState({
            details: {
              title: 'Email alterado com sucesso!',
            },
          });
        })
    } else {
      this.checkId()
        .then((res) => {
          this.confirmEmail()
            .then((r) => {
              let details = this.state.details;
              res.data.name = res.data.name.toLowerCase();
              details.title = res.data.name.charAt(0).toUpperCase() + res.data.name.slice(1) + ', seu email foi confirmado com sucesso !';
              details.text = ''
              this.setState( {details} );    
            })
            .catch((error) => {
              this.props.history.push('/404')
            })
        })  
    }
  }

  checkId = () => {
    return authInstance
      .post('/authentication/user/check/email-confirmation', {
        idConfirmation: this.props.match.params.code,
      });
  }

  confirmEmail = () => {
    return authInstance
      .post('authentication/user/confirm/email', {
        idConfirmation: this.props.match.params.code,
      });
  }

  changeEmail = token => authInstance.get('/authentication/user/set/email', {
    headers: { Authorization: `Bearer ${token}` },
  })

  render() {
    const { classes } = this.props;

    return (
      <Grid container className={classes.container} alignContent="center">
        <Paper elevation={2} className={classes.paperContainer}>
          <Grid item xs={12}>
            <img src={Error404} alt="Erro 404" className={classes.image} />
          </Grid>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" className={classes.confirmationText}>
              {this.state.details.title}
            </Typography>
            {/* <Typography align="center" variant="body1" color="textSecondary" paragraph>
              {this.state.details.text}
            </Typography> */}
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" className={classes.button} component={Link} to="/">
              Continuar para o Puntu
            </Button>
          </Grid>
        </Paper>

      </Grid>
    )
  }
}

export default withStyles(styles)(EmailConfirmation);
